import React, { lazy, Suspense, useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";

import "./App.scss";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Image from "react-bootstrap/Image";
import Badge from "react-bootstrap/Badge";

import { app } from "./context/firebaseConfig";
import { UserContext } from "./context/userContext";
import PrivateRouter from "./extra/PrivateRouter";
import { getAddress, getUserData } from "./extra/db";

import Logo from "./images/LogoCirculo800x800.png";
import Cart from "./images/cart.png";

import Home from "./components/Home";
import NoMatch from "./extra/NoMatch";
import Popstart from "./components/Popstart";

const Login = lazy(() => import("./components/Login"));
const Signup = lazy(() => import("./components/Signup"));
const Perfil = lazy(() => import("./components/Perfil"));
const AddAddress = lazy(() => import("./components/AddAddress"));
const ShopCart = lazy(() => import("./components/ShopCart"));
const Menu = lazy(() => import("./components/Menu"));
const Sucursales = lazy(() => import("./components/Sucursales"));
const BajaCalifornia = lazy(() =>
    import("./components/sucursales/BajaCalifornia")
);
const Nativitas = lazy(() => import("./components/sucursales/Nativitas"));
const Girasoles = lazy(() => import("./components/sucursales/Girasoles"));

const Terminos = lazy(() => import("./components/Terminos"));
const Privacidad = lazy(() => import("./components/Privacidad"));

const App = () => {
    const { user, order, dispatch } = useContext(UserContext);

    useEffect(() => {
        app.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: "LOGOUT_USER",
                    payload: null,
                });
            } else {
                getUserData(user.uid).then((res) => {
                    dispatch({
                        type: "USER_DATA",
                        payload: res,
                    });
                });

                getAddress(user.uid).then((res) => {
                    dispatch({
                        type: "SET_ADDRESS",
                        payload: res,
                    });
                });

                dispatch({
                    type: "LOGIN_USER",
                    payload: {
                        uid: user.uid,
                        displayName: user.displayName,
                    },
                });
            }
        });
    }, [dispatch]);

    useEffect(() => {
        ///window.localStorage.setItem('user', JSON.stringify(user))
    }, [user]);

    useEffect(() => {
        //window.localStorage.setItem('order', JSON.stringifyorder)
    }, [order]);

    return (
        <Router>
            <ul className="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>

            <Container fluid style={{ padding: 0, marginBottom: "76px" }}>
                <Navbar
                    collapseOnSelect
                    expand="lg"
                    variant="dark"
                    style={{ backgroundColor: "#9c4b97" }}
                    fixed="top"
                >
                    <Navbar.Brand href="/">
                        <Link to="/">
                            <img
                                src={Logo}
                                width="50"
                                height="50"
                                className="d-inline-block align-top"
                                alt="React Bootstrap logo"
                            />
                        </Link>
                    </Navbar.Brand>

                    <Nav.Item href="/carrito" as={Link} to="/carrito">
                        <Image src={Cart} height="40" />
                        <Badge variant="light" pill>
                            {order.bebidas.length}
                        </Badge>
                    </Nav.Item>

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse
                        id="responsive-navbar-nav"
                        style={{ backgroundColor: "#9c4b97" }}
                    >
                        <Nav className="ml-auto ">
                            <Nav.Link
                                href="/"
                                style={{
                                    padding: "0px",
                                    fontSize: "20px",
                                    fontFamily: "Biko",
                                    textDecorationColor: "#9c4b97",
                                }}
                            >
                                <Link to="/" className="nav-link">
                                    Inicio
                                </Link>
                            </Nav.Link>

                            <Nav.Link
                                href="/menu"
                                style={{
                                    padding: "0px",
                                    fontSize: "20px",
                                    fontFamily: "Biko",
                                    textDecorationColor: "#9c4b97",
                                }}
                            >
                                <Link to="/menu" className="nav-link">
                                    Menú
                                </Link>
                            </Nav.Link>

                            <NavDropdown
                                title="Sucursales"
                                style={{
                                    padding: "0px",
                                    fontSize: "20px",
                                    fontFamily: "Biko",
                                    backgroundColor: "#9c4b97",
                                }}
                            >
                                <NavDropdown.Item
                                    href="/baja-california"
                                    style={{
                                        padding: "0px",
                                        fontSize: "20px",
                                        fontFamily: "Biko",
                                        backgroundColor: "#9c4b97",
                                    }}
                                >
                                    <Link
                                        to="/baja-california"
                                        className="nav-link"
                                    >
                                        Baja California
                                    </Link>
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                    href="/nativitas"
                                    style={{
                                        padding: "0px",
                                        fontSize: "20px",
                                        fontFamily: "Biko",
                                        backgroundColor: "#9c4b97",
                                    }}
                                >
                                    <Link to="/nativitas" className="nav-link">
                                        Nativitas
                                    </Link>
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                    href="/girasoles"
                                    style={{
                                        padding: "0px",
                                        fontSize: "20px",
                                        fontFamily: "Biko",
                                        backgroundColor: "#9c4b97",
                                    }}
                                >
                                    <Link to="/girasoles" className="nav-link">
                                        Girasoles
                                    </Link>
                                </NavDropdown.Item>

                                <NavDropdown.Divider />

                                <NavDropdown.Item
                                    href="/proximamente"
                                    style={{
                                        padding: "0px",
                                        fontSize: "20px",
                                        fontFamily: "Biko",
                                        backgroundColor: "#9c4b97",
                                    }}
                                >
                                    <Link
                                        to="/proximamente"
                                        className="nav-link"
                                    >
                                        Proximas ubicaciones
                                    </Link>
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link
                                href="/perfil"
                                style={{
                                    padding: "0px",
                                    fontSize: "20px",
                                    fontFamily: "Biko",
                                    textDecorationColor: "#9c4b97",
                                }}
                            >
                                <Link to="/perfil" className="nav-link">
                                    Perfil
                                </Link>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>

            <Suspense fallback={() => <></>}>
                <Switch>
                    <Route path="/login">
                        <Login />
                    </Route>

                    <Route path="/registro">
                        <Signup />
                    </Route>

                    <PrivateRouter path="/perfil">
                        <Perfil />
                    </PrivateRouter>

                    <PrivateRouter path="/agregar">
                        <AddAddress />
                    </PrivateRouter>

                    <Route path="/proximamente">
                        <Sucursales />
                    </Route>

                    <Route path="/menu">
                        <Menu />
                    </Route>

                    <Route path="/baja-california">
                        <BajaCalifornia />
                    </Route>

                    <Route path="/nativitas">
                        <Nativitas />
                    </Route>

                    <Route path="/girasoles">
                        <Girasoles />
                    </Route>

                    <Route path="/carrito">
                        <ShopCart />
                    </Route>

                    <Route path="/tyc">
                        <Terminos />
                    </Route>

                    <Route path="/privacidad">
                        <Privacidad />
                    </Route>

                    <Route exact path="/">
                        <Home />
                    </Route>

                    <Route path="/popstars">
                        <Popstart />
                    </Route>

                    <Route path="*">
                        <NoMatch />
                    </Route>
                </Switch>
            </Suspense>
        </Router>
    );
};

export default App;
